const _excluded = ["applyTime"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from "prop-types";
import { EuiButtonEmpty } from '../../../button';
import { EuiIcon } from '../../../icon';
import { EuiPopover } from '../../../popover';
import { EuiTitle } from '../../../title';
import { EuiText } from '../../../text';
import { useEuiI18n } from '../../../i18n';
import { EuiQuickSelect } from './quick_select';
import { EuiCommonlyUsedTimeRanges } from './commonly_used_time_ranges';
import { EuiRecentlyUsed } from './recently_used';
import { EuiRefreshInterval } from '../../auto_refresh/refresh_interval';
export var EuiQuickSelectPopover = function EuiQuickSelectPopover(_ref) {
  var _applyTime = _ref.applyTime,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    prevQuickSelect = _useState2[0],
    setQuickSelect = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var closePopover = useCallback(function () {
    return setIsOpen(false);
  }, []);
  var togglePopover = useCallback(function () {
    return setIsOpen(function (isOpen) {
      return !isOpen;
    });
  }, []);
  var applyTime = useCallback(function (_ref2) {
    var start = _ref2.start,
      end = _ref2.end,
      quickSelect = _ref2.quickSelect,
      _ref2$keepPopoverOpen = _ref2.keepPopoverOpen,
      keepPopoverOpen = _ref2$keepPopoverOpen === void 0 ? false : _ref2$keepPopoverOpen;
    _applyTime({
      start: start,
      end: end
    });
    if (quickSelect) {
      setQuickSelect(quickSelect);
    }
    if (!keepPopoverOpen) {
      closePopover();
    }
  }, [_applyTime, closePopover]);
  var buttonlabel = useEuiI18n('euiQuickSelectPopover.buttonLabel', 'Date quick select');
  var quickSelectButton = ___EmotionJSX(EuiButtonEmpty, {
    className: "euiFormControlLayout__prepend",
    contentProps: {
      className: 'euiQuickSelectPopover__buttonContent'
    },
    onClick: togglePopover,
    "aria-label": buttonlabel,
    title: buttonlabel,
    size: "xs",
    iconType: "arrowDown",
    iconSide: "right",
    isDisabled: props.isDisabled,
    "data-test-subj": "superDatePickerToggleQuickMenuButton"
  }, ___EmotionJSX(EuiIcon, {
    type: "calendar"
  }));
  return ___EmotionJSX(EuiPopover, {
    button: quickSelectButton,
    isOpen: isOpen,
    closePopover: closePopover,
    anchorPosition: "downLeft"
  }, ___EmotionJSX(EuiQuickSelectPanels, _extends({}, props, {
    applyTime: applyTime,
    prevQuickSelect: prevQuickSelect
  })));
};
EuiQuickSelectPopover.propTypes = {
  applyRefreshInterval: PropTypes.func,
  applyTime: PropTypes.func.isRequired,
  commonlyUsedRanges: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired).isRequired,
  customQuickSelectPanels: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.element.isRequired
  }).isRequired),
  customQuickSelectRender: PropTypes.func,
  dateFormat: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isPaused: PropTypes.bool.isRequired,
  recentlyUsedRanges: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired).isRequired,
  refreshInterval: PropTypes.number.isRequired,
  intervalUnits: PropTypes.oneOf(["s", "m", "h"]),
  start: PropTypes.string.isRequired,
  timeOptions: PropTypes.shape({
    timeTenseOptions: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
    timeUnitsOptions: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
    relativeOptions: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.oneOf(["s", "m", "h", "d", "w", "M", "y"]).isRequired, PropTypes.oneOf(["s+", "m+", "h+", "d+", "w+", "M+", "y+"]).isRequired]).isRequired
    }).isRequired).isRequired,
    relativeRoundingLabels: PropTypes.any.isRequired,
    refreshUnitsOptions: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
    commonDurationRanges: PropTypes.arrayOf(PropTypes.shape({
      end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
      label: PropTypes.string,
      start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
    }).isRequired).isRequired
  }).isRequired
};
export var EuiQuickSelectPanels = ({
  start,
  end,
  dateFormat,
  timeOptions,
  commonlyUsedRanges,
  recentlyUsedRanges,
  customQuickSelectPanels,
  customQuickSelectRender,
  isPaused,
  refreshInterval,
  intervalUnits,
  applyRefreshInterval,
  applyTime,
  prevQuickSelect
}) => {
  const quickSelectElement = <EuiQuickSelect applyTime={applyTime} start={start} end={end} prevQuickSelect={prevQuickSelect} timeOptions={timeOptions} />;
  const commonlyUsedElement = <EuiCommonlyUsedTimeRanges applyTime={applyTime} commonlyUsedRanges={commonlyUsedRanges} />;
  const recentlyUsedElement = <EuiRecentlyUsed applyTime={applyTime} commonlyUsedRanges={commonlyUsedRanges} dateFormat={dateFormat} recentlyUsedRanges={recentlyUsedRanges} />;
  const refreshIntervalElement = applyRefreshInterval && <EuiRefreshInterval onRefreshChange={applyRefreshInterval} isPaused={isPaused} refreshInterval={refreshInterval} intervalUnits={intervalUnits} />;
  const customQuickSelectPanelsElement = useMemo(() => {
    if (!customQuickSelectPanels) {
      return null;
    }
    return customQuickSelectPanels.map(({
      title,
      content
    }) => {
      return <div key={title} className="euiQuickSelectPopover__panel">
          <EuiTitle size="xxxs">
            <span>{title}</span>
          </EuiTitle>
          <EuiText size="s" className="euiQuickSelectPopover__section">
            {React.cloneElement(content, {
            applyTime
          })}
          </EuiText>
        </div>;
    });
  }, [customQuickSelectPanels, applyTime]);
  return <div className="euiQuickSelectPopover__content" data-test-subj="superDatePickerQuickMenu">
      {customQuickSelectRender ? customQuickSelectRender({
      quickSelect: quickSelectElement,
      commonlyUsedRanges: commonlyUsedElement,
      recentlyUsedRanges: recentlyUsedElement,
      refreshInterval: refreshIntervalElement,
      customQuickSelectPanels: customQuickSelectPanelsElement
    }) : <>
          {quickSelectElement}
          {commonlyUsedElement}
          {recentlyUsedElement}
          {refreshIntervalElement}
          {customQuickSelectPanelsElement}
        </>}
    </div>;
};
EuiQuickSelectPanels.propTypes = {
  prevQuickSelect: PropTypes.shape({
    timeTense: PropTypes.string.isRequired,
    timeValue: PropTypes.number.isRequired,
    timeUnits: PropTypes.oneOf(["s", "m", "h", "d", "w", "M", "y"]).isRequired
  })
};
try {
  EuiQuickSelectPopover.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
    description: '',
    displayName: 'EuiQuickSelectPopover',
    methods: [],
    props: {
      applyRefreshInterval: {
        defaultValue: null,
        description: '',
        name: 'applyRefreshInterval',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: 'ApplyRefreshInterval'
        }
      },
      applyTime: {
        defaultValue: null,
        description: '',
        name: 'applyTime',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'ApplyTime'
        }
      },
      commonlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'commonlyUsedRanges',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'DurationRange[]'
        }
      },
      customQuickSelectPanels: {
        defaultValue: null,
        description: '',
        name: 'customQuickSelectPanels',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: 'QuickSelectPanel[]'
        }
      },
      customQuickSelectRender: {
        defaultValue: null,
        description: '',
        name: 'customQuickSelectRender',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: '(options: CustomQuickSelectRenderOptions) => ReactNode'
        }
      },
      dateFormat: {
        defaultValue: null,
        description: '',
        name: 'dateFormat',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      end: {
        defaultValue: null,
        description: '',
        name: 'end',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      isDisabled: {
        defaultValue: null,
        description: '',
        name: 'isDisabled',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      isPaused: {
        defaultValue: null,
        description: '',
        name: 'isPaused',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      recentlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'recentlyUsedRanges',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'DurationRange[]'
        }
      },
      refreshInterval: {
        defaultValue: null,
        description: '',
        name: 'refreshInterval',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      intervalUnits: {
        defaultValue: null,
        description: '',
        name: 'intervalUnits',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'RefreshUnitsOptions',
          value: [{
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"h"'
          }]
        }
      },
      start: {
        defaultValue: null,
        description: '',
        name: 'start',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      timeOptions: {
        defaultValue: null,
        description: '',
        name: 'timeOptions',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'TimeOptions'
        }
      }
    },
    extendedInterfaces: ['EuiQuickSelectPopoverProps']
  };
} catch (e) {}
try {
  EuiQuickSelectPanels.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
    description: '',
    displayName: 'EuiQuickSelectPanels',
    methods: [],
    props: {
      end: {
        defaultValue: null,
        description: '',
        name: 'end',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      dateFormat: {
        defaultValue: null,
        description: '',
        name: 'dateFormat',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      commonlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'commonlyUsedRanges',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'DurationRange[]'
        }
      },
      customQuickSelectPanels: {
        defaultValue: null,
        description: '',
        name: 'customQuickSelectPanels',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: 'QuickSelectPanel[]'
        }
      },
      customQuickSelectRender: {
        defaultValue: null,
        description: '',
        name: 'customQuickSelectRender',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: '(options: CustomQuickSelectRenderOptions) => ReactNode'
        }
      },
      isPaused: {
        defaultValue: null,
        description: '',
        name: 'isPaused',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      recentlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'recentlyUsedRanges',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'DurationRange[]'
        }
      },
      refreshInterval: {
        defaultValue: null,
        description: '',
        name: 'refreshInterval',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      start: {
        defaultValue: null,
        description: '',
        name: 'start',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      timeOptions: {
        defaultValue: null,
        description: '',
        name: 'timeOptions',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'TimeOptions'
        }
      },
      applyTime: {
        defaultValue: null,
        description: '',
        name: 'applyTime',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: true,
        type: {
          name: 'ApplyTime'
        }
      },
      applyRefreshInterval: {
        defaultValue: null,
        description: '',
        name: 'applyRefreshInterval',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: 'ApplyRefreshInterval'
        }
      },
      intervalUnits: {
        defaultValue: null,
        description: '',
        name: 'intervalUnits',
        parent: {
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        },
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'EuiQuickSelectPopoverProps'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'RefreshUnitsOptions',
          value: [{
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"h"'
          }]
        }
      },
      prevQuickSelect: {
        defaultValue: null,
        description: '',
        name: 'prevQuickSelect',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/date_picker/super_date_picker/quick_select_popover/quick_select_popover.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'QuickSelect'
        }
      }
    },
    extendedInterfaces: ['EuiQuickSelectPopoverProps']
  };
} catch (e) {}